var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "frame",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4417 6.19568L4.89166 17.5907C2.875 18.4007 2.88666 19.5257 4.52166 20.0273L12.1083 22.394L29.6617 11.319C30.4917 10.814 31.25 11.0857 30.6267 11.639L16.405 24.474H16.4017L16.405 24.4757L15.8817 32.2957C16.6483 32.2957 16.9867 31.944 17.4167 31.529L21.1017 27.9457L28.7667 33.6073C30.18 34.3857 31.195 33.9857 31.5467 32.299L36.5783 8.58568C37.0933 6.52068 35.79 5.58568 34.4417 6.19568Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.329e1bdc6592dfa258201f98baa04f4f.svg";
export { ForwardRef as ReactComponent };